import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
      sortable: true,
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};

export default configTable;
